import { IconButton } from "@commonlibs";
import styled, { css } from "styled-components";
import NumericTextField from "ui/common/components/input/NumericTextField/NumericTextField";
import PencilIcon from "ui/common/icons/PencilIcon";

export const MainRow = styled.div(
    () => css`
        display: grid;
        gap: 5px;
        grid-template-columns: 1fr 25px;
    `,
);

export const IconButtonRoot = styled(IconButton)(
    () => css`
        height: 100%;
    `,
);

export const PencilIconRoot = styled(PencilIcon)(
    () => css`
        position: absolute;
        bottom: 25px;
        width: 25px;
        height: 25px;
    `,
);

export const NumericTextFieldRoot = styled(NumericTextField)(
    () => css`
        .Readonly .TextInput {
            background-color: #ebebeb;
        }
    `,
);
